const SLIButtonStyle = {
  DARK: 'bg-SLIGreen text-SLIWhite',
  LIGHT: 'bg-SLIWhite text-SLIGreen border-2 border-SLIGreen hover:bg-SLIGreen hover:text-SLIWhite',
};

const SLIButton = ({ label, onClick, className, buttonStyle = SLIButtonStyle.DARK }) => {
  return (
    <button
      className={`${buttonStyle} text-sm font-semibold py-2 w-fit rounded-full ${className}`}
      onClick={onClick}
    >
      {label}
    </button>
  );
};

export { SLIButton, SLIButtonStyle };
